import { render } from "./addPointsManager.vue?vue&type=template&id=5c621d22&scoped=true"
import script from "./addPointsManager.vue?vue&type=script&lang=js"
export * from "./addPointsManager.vue?vue&type=script&lang=js"

import "./addPointsManager.vue?vue&type=style&index=0&id=5c621d22&lang=scss"
import "./addPointsManager.vue?vue&type=style&index=1&id=5c621d22&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c621d22"],['__file',"src/views/marketing/components/addPointsManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c621d22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c621d22', __exports__)) {
    console.log('reload')
    api.reload('5c621d22', __exports__)
  }
  
  module.hot.accept("./addPointsManager.vue?vue&type=template&id=5c621d22&scoped=true", () => {
    console.log('re-render')
    api.rerender('5c621d22', render)
  })

}


export default __exports__